<template>
  <q-chat-message
    class="c-chat-message c-chat-user-message"
    :name="chat.name"
    :text="chat.text"
    :stamp="chat.stamp"
    :sent="chat.sent"
  >
    <template #avatar>
      <q-avatar class="c-chat-avatar" icon="fa-duotone fa-user" />
    </template>
  </q-chat-message>
</template>

<script setup>
// Define props for the chat component
const props = defineProps({
  chat: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});
</script>

<style lang="scss">
.q-message.c-chat-message {
  .q-message-container {
    @apply tw-gap-4;
  }

  .q-avatar.c-chat-avatar {
    @apply tw-bg-slate-200 tw-text-[35px];
  }

  .q-message-name {
    @apply tw-mb-1 tw-text-sm;
  }

  .q-message-text {
    @apply tw-p-3 tw-pb-1;

    &.q-message-text--received {
      @apply tw-bg-slate-200 tw-text-slate-200;
    }

    &.q-message-text--sent {
      @apply tw-bg-blue-100;
    }
  }

  .q-message-stamp {
    @apply tw-mt-2 tw-text-xs;
  }
}
</style>
